import React, { useEffect, useMemo } from "react";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Newsletter from "../components/Newsletter";
import Breadcrumbs from "../components/Breadcrumbs";
import BrandsCard from "../components/BrandsCard";
import brandsData from "../data/brands.json";
/*import GalleryMini from "../components/GalleryMini";*/
import { useQuery } from "@tanstack/react-query";
import { fetchCollections } from "../lib/medusa";
import { getTranslatedPath } from "../utils/languageUtils";

export default function Brands({ setHeader }) {
  const { t, i18n } = useTranslation();
  const { data: collections, isLoading } = useQuery({
    queryKey: ["collections"],
    queryFn: fetchCollections,
  });
  const brandCollections = useMemo(() => {
    if (isLoading && !collections) return [];

    const remoteCollections = Array.isArray(collections) ? collections : [];
    const hasMoltonBrown = remoteCollections.some(
      (brand) => brand.handle === "molton-brown"
    );

    if (hasMoltonBrown) return remoteCollections;

    const moltonBrown = brandsData["molton-brown"];

    return [
      ...remoteCollections,
      {
        id: "local-molton-brown",
        handle: moltonBrown.url,
        title: moltonBrown.title,
        metadata: {
          logo: moltonBrown.logo,
        },
      },
    ];
  }, [collections, isLoading]);
  const currentPaths = getTranslatedPath(i18n.language);
  const alternateLinks = [
    { hrefLang: "en", href: getTranslatedPath("en")["brands"] },
    { hrefLang: "sr", href: getTranslatedPath("sr")["brands"] },
  ];
  const breadcrumbs = [
    { name: t("header.home.menuTitle"), url: `/${i18n.language}` },
    { name: t("header.brands.pageTitle"), url: currentPaths["brands"] },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  return (
    <>
      <Seo
        title={t("header.brands.pageTitle")}
        description={t("header.brands.metaDescription")}
        path={currentPaths["brands"]}
        alternateLinks={alternateLinks}
        breadcrumbs={breadcrumbs}
      />
      <Loader />
      {/* // <!-- Main content Start --> */}
      <div className="main-content">
        {/* <!-- Breadcrumbs Start --> */}
        <div className="rs-breadcrumbs img2">
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">
                {t("home.brands.title")}
                {/*<span className="watermark">{home.brands.title}</span>*/}
              </h1>
            </div>
          </div>
        </div>
        <Breadcrumbs />
        {/* <!-- Breadcrumbs End --> */}

        {/* <!-- Brands Section Start --> */}
        <div
          id="rs-our-sponsor"
          className="rs-our-sponsor blue-bg style1 home3-sponsor-style height-ctrl pt-130 md-pb-70 md-pt-70"
        >
          <div className="container">
            <div className="sec-title text-center mb-60">
              <h2 className="title title2 title3 text-middle">
                {t("home.brands.title")}
              </h2>
            </div>
            <div className="row">
              {brandCollections.map((brand) => (
                <BrandsCard key={brand.title} brand={brand} />
              ))}
            </div>
          </div>
        </div>
        {/* <!-- Brands Section End -->  */}

        {/* <!-- Newsletter section start --> */}
        <div className="rs-newsletter blue-bg style1 pt-90 md-pt-60 mb--65">
          <Newsletter />
        </div>

        {/* <!-- Newsletter section end --> */}
      </div>
      {/* // <!-- Main content End --> */}
    </>
  );
}
